<!--
 * @Author: p_fy
 * @Date: 2019-07-17 13:47:49
 * @LastEditors: p_fy
 * @LastEditTime: 2019-08-26 10:00:17
 * @Description: 邀请看仓窗口，查询个人供给列表，状态：普仓、罐区
 -->
<!-- 邀请看仓 -->
<template>
  <div class="transport-news">
    <el-dialog
      :visible.sync="invitationVisible"
      title="邀请看仓"
      width="80%"
      @close="$emit('close', false)"
    >
      <div class="demand-head">
        <div v-if="warehousingType == '1'" class="invite-head-form">
          <div class="fileds">
            <el-form ref="form" :model="queryInviParams" :inline="true">
              <div class="invite-condition">
                <el-form-item label="租单名称:" prop="supplyName">
                  <el-input v-model="queryInviParams.supplyName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="货物类型:" prop="storageType">
                  <el-select v-model="queryInviParams.storageType" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in storageType.storageType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="库房位置:" prop="storageLocation">
                  <el-cascader
                    v-model="queryInviParams.storageLocation"
                    :options="storageType.area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item label="可租用面积:" prop="rentableStartArea">
                  <div class="invite-area">
                    <el-row>
                      <el-col :span="11">
                        <el-form-item prop="rentableStartArea">
                          <el-input v-model="queryInviParams.rentableStartArea" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <span>至</span>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item prop="rentableStopArea">
                          <el-input v-model="queryInviParams.rentableStopArea" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="loadInvitationData"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="resetForm"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-if="warehousingType != '1'" class="invite-head-form">
          <div class="fileds">
            <el-form ref="tankform" :model="tankqueryInviParams" :inline="true">
              <div class="invite-condition">
                <el-form-item label="租单名称:" prop="supplyName">
                  <el-input v-model="tankqueryInviParams.supplyName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="货物类型:" prop="storageType">
                  <el-select v-model="tankqueryInviParams.storageType" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in storageType.storageType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="起租灌数:" prop="leasePotCount">
                  <el-input v-model="tankqueryInviParams.leasePotCount" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="库房位置:" prop="storageLocation">
                  <el-cascader
                    v-model="tankqueryInviParams.storageLocation"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <el-form-item label="罐区面积:" prop="potStartArea">
                  <div class="invite-area">
                    <el-row>
                      <el-col :span="11">
                        <el-form-item prop="potStartArea">
                          <el-input v-model="tankqueryInviParams.potStartArea" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <span>至</span>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item prop="potEndArea">
                          <el-input v-model="tankqueryInviParams.potEndArea" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="loadInvitationData"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="tankResetForm"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-loading="viewManager.loading" class="invitation-data">
          <div class="invitation-data-header">
            <ul>
              <li>租单名称</li>
              <li>储存类型</li>
              <li>库房位置</li>
              <li v-if="warehousingType == '1' ">可租用面积</li>
              <li v-if="warehousingType == '1' ">期望租金</li>
              <li v-if="warehousingType != '1' ">罐区面积</li>
              <!-- <li v-if="warehousingType != '1' ">起租灌数</li> -->
              <li v-if="warehousingType != '1' ">期望租金</li>
              <li>操作</li>
            </ul>
          </div>
          <div class="invitation-data-body">
            <!-- <template v-if="!viewManager.loading && invitationData.length < 1">
              <div class="no-data-info">
                <font>暂无匹配数据</font>
              </div>
            </template> -->
      
            <template v-for="(item, index) of invitationData">
              <div :key="index" class="data-item">
                <ul>
                  <el-tooltip class="item" effect="dark" :content="item.supplyName" placement="top">
                    <li :title="item.supplyName">{{ item.supplyName }}</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType == '1' " class="item" effect="dark" :content="item.storageTypeLabel" placement="top">
                    <li :title="item.storageTypeLabel">{{ item.storageTypeLabel }}</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType != '1' " class="item" effect="dark" :content="item.tankTypeLabel" placement="top">
                    <li :title="item.tankTypeLabel">{{ item.tankTypeLabel }}</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.storageLocationLabel" placement="top">
                    <li :title="item.storageLocationLabel">{{ item.storageLocationLabel }}</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType == '1' " class="item" effect="dark" :content="`${item.rentableArea}㎡`" placement="top">
                    <li :title="item.rentableArea">{{ item.rentableArea }}㎡</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType == '1' " class="item" effect="dark" :content="`${item.expectPrice}m²/天`" placement="top">
                    <li :title="item.expectPrice">{{ item.expectPrice }}m²/天</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType != '1' " class="item" effect="dark" :content="`${item.potArea}m³`" placement="top">
                    <li :title="item.potArea">{{ item.potArea }}m³</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType != '1' " class="item" effect="dark" :content="`${item.expectPrice}m³/天`" placement="top">
                    <li :title="item.expectPrice">{{ item.expectPrice }}m³/天</li>
                  </el-tooltip>
                  <li>
                    <el-button v-if="item.invithid" type="text" style="color: #66b1ff !important;" @click="inviSummit(item)">邀请</el-button>
                    <el-button v-else type="text" style="color:#be2316;">已邀请</el-button>
                    <el-divider direction="vertical" />
                    <el-button plain size="small" @click="inviteInfo(item)">
                      详情
                      <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
                    </el-button>
                  </li>
                </ul>
                <storeSupplyInfo v-if="!item.hidden && warehousingType == '1' " style="position: initial;" :supply="item" />
                <tankSupplyInfo v-if="!item.hidden && warehousingType != '1' " style="position: initial;" :supply="item" />
              </div>
            </template>
          </div>
          <div class="invitation-data-pagination">
            <el-pagination
              :current-page="inviPageParam.pageNo"
              :total="inviPageParam.total"
              :page-size="inviPageParam.pageSize"
              layout="prev, pager, next, jumper,total, sizes"
              @current-change="invitationChangeCurrent"
              @size-change="invitationChangeSize"
            />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 普仓供应详情
import storeSupplyInfo from '../../personal/store/store-supply-list/components/storeSupplyInfo'
// 罐区供应详情
import tankSupplyInfo from '../../personal/store/tank-supply-list/components/tankSupplyInfo'
// 邀请看仓接口调用
import { invitationList, invitationSave, getArea, getDict } from '@/api/cloud/inviteWarehousing'
// import { tableClass } from '@/api/cloud/storage-demand-info/components/StorageDemandItemsParam' // 仓储供给信息、表单参数列表
import { DatabaseUtil } from '@/utils/databaseUtils'
import { findPageDemand } from '@/api/cloud/storage-demand-info/components/storageDemandItems'

const dataBase = new DatabaseUtil()
// const table = tableClass.getTable() // 引用表格参数类(包含查询条件的表单)
export default {
  name: 'InviteWarehousing',
  components: {
    storeSupplyInfo,
    tankSupplyInfo
  },
  props: {
    invitationManager: { type: Boolean, default: () => false }, // 弹窗控制
    invitationForm: { type: Object, default: () => {} }, // 当前元素
    warehousingType: { type: String, default: () => '' } // 仓库状态 1.普仓2.罐区
  },
  data() {
    return {
      invitationVisible: this.invitationManager,
      inviPageParam: { // 分页参数
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      invitationData: {},
      viewManager: {
        loading: true
      },
      area: [],
      allSelection: false,
      queryInviParams: {
        supplyName: null,
        storageType: null,
        rentableStartArea: null,
        rentableStopArea: null,
        storageLocation: null,
        publishStatus: '2'
      },
      tankqueryInviParams: {
        supplyName: null,
        storageType: null,
        leasePotCount: null,
        potStartArea: null,
        potEndArea: null,
        storageLocation: null,
        publishStatus: '2'
      },
      storageType: {
        storageType: [],
        area: []
      }
    }
  },
  watch: {
    invitationManager() { // 监听窗口变化
      this.invitationVisible = this.invitationManager
      if (this.invitationVisible) {
        this.loadInvitationData()
      }
    }
  },
  created() {
    console.log(this.invitationForm)
    this.getArea()
    this.getStorageType()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadInvitationData()
      }
    }
  },
  methods: {
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
      }, 100)
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.storageType.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.storageType.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.storageType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 重置
    resetForm() {
      this.$refs['form'].resetFields()
      this.queryInviParams.storageLocation = null
    },
    // 罐区重置
    tankResetForm() {
      this.$refs['tankform'].resetFields()
      this.tankqueryInviParams.storageLocation = null
    },
    // 监听当前页数
    invitationChangeSize(size) {
      this.inviPageParam.pageSize = size
      this.loadInvitationData()
    },
    // 监听页数变化
    invitationChangeCurrent(current) {
      this.inviPageParam.pageNo = current
      this.loadInvitationData()
    },
    // 详情展示
    inviteInfo(invite) {
      if (invite.hidden) {
        this.invitationData.map(res => {
          console.log(res)
          res.hidden = true
          return res
        })
      }
      invite.hidden = !invite.hidden
    },
    // 根据仓库状态处理条件
    loadInvitationData() {
      this.viewManager.loading = true
      if (this.warehousingType == '1') {
        const params = Object.assign(this.queryInviParams, this.inviPageParam)
        params.warehousingType = this.warehousingType
        this.loadData(params)
      } else {
        const params = Object.assign(this.tankqueryInviParams, this.inviPageParam)
        params.warehousingType = this.warehousingType
        this.loadData(params)
      }
    },
    // 根据Uid查询仓库信息
    loadData(params) {
      const dataParams = JSON.parse(JSON.stringify(params))
      if (dataParams.storageLocation != null && dataParams.storageLocation.length > 0) {
        dataParams.storageLocation = dataParams.storageLocation.join('#')
      }

      // findPageDemand(dataParams).then(res => {
      //   console.log(res)
      //   console.log(res)
      //   const invit = []
      //   res.result.rows.forEach(res => {
      //     if (res != null) {
      //       res.hidden = true
      //       res.invithid = true
      //       res.selection = false
      //       invit.push(res)
      //     }
      //   })
      //   this.invitationData = invit
      //   this.inviPageParam.total = res.result.total
      // }).catch((err) => {
      //   console.log(err)
      //   this.inviPageParam.total = this.invitationData.length
      // }).finally(() => {
      //   this.viewManager.loading = false
      // })


      invitationList(dataParams).then((res) => {
        console.log(res)
        console.log(res)
        const invit = []
        res.result.rows.forEach(res => {
          if (res != null) {
            res.hidden = true
            res.invithid = true
            res.selection = false
            invit.push(res)
          }
        })
        this.invitationData = invit
        this.inviPageParam.total = res.result.total
      }).catch((err) => {
        console.log(err)
        this.inviPageParam.total = this.invitationData.length
      }).finally(() => {
        this.viewManager.loading = false
      })
    },
    // 批量邀请
    invitationSelSummit() {
      const selData = []
      this.invitationData.forEach(res => {
        if (res.selection) {
          selData.push(res.id)
        }
      })
      invitationSave({ inviteId: selData[0], demandId: this.invitationForm.id, warehousingType: this.warehousingType }).then((res) => {

        this.$message({
          offset: 100,
          message: '邀请成功!',
          type: 'success'
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 单条邀请
    inviSummit(demand) {
      console.log(demand)
      invitationSave({ supplyId: demand.id, demandId: this.invitationForm.id, invitedUserId: this.invitationForm.createBy.userId, warehousingType: this.warehousingType }).then((res) => {
      console.log(res)

      
      this.$message({
          offset: 100,
          message: '邀请成功!',
          type: 'success'
        })


        demand.invithid = false
      }).catch((err) => {
        console.log(err)
      })
    },
    invitationFormSummit() {
      this.loadInvitationData()
    },
    // 邀请全选
    invitationSelection() {
      this.invitationData.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 邀请子项选择
    invitationChange() {
      this.allSelection = this.invitationData.every(i => i.selection)
    }
  }
}
</script>

<style scoped lang='scss'>
  $main-color: #be2316;
   $main-color: #be2316;
  .transport-news{
    margin-bottom: 1rem;
  }
  /deep/.demand-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .invite-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        width: 100%;
        // flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
        .invite-condition{
          display: flex;
          flex-wrap: wrap;
          /deep/.el-form-item .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            width: 217px;
            .invite-area{
              display: inline-flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              padding: 3px 10px;
              -webkit-appearance: none;
              background-color: #FFF;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #DCDFE6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              width: 100%;
              /deep/.el-form-item__content{
                width: auto;
              }
              &:focus {
                  border-color: #409EFF;
                  outline: 0;
              }
              &:hover {
                  border-color: #C0C4CC;
              }
              .el-form-item{
                padding-right: 0px;
                width: 100%;
                margin-right: 0 !important;
                /deep/.el-input .el-input__inner {
                    border: 0px solid #DCDFE6;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                }
              }
            }
          }
          .el-form-item{
              display: flex;
              -webkit-box-pack: end;
              -ms-flex-pack: end;
              justify-content: flex-end;
              padding-right: 22px;
              width: 50%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              margin-right: 0 !important;
          }
        }
      }
      .buttons {
        flex: 0 1 35%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }
  /deep/.main-wrap{
    margin-top: 1rem;
    .main{
      width: 1200px;
      margin: 0 auto 1rem;
      border:1px solid rgba(229,229,229,1);
      box-sizing: border-box;
      .el-form-item{
        padding-left: 20px;
        padding-right: 20px;
        .el-tag{
          margin-right: 1rem;
        }
      }
      .el-form{
        .selected-conditions{
          background-color: #F6F6F6;
          .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            .el-tag{
              margin-top: auto;
              margin-bottom: auto;
            }
          }
          .clear-conditions{
            cursor: pointer;
            color:  #999999;
            align-items: flex-end;
            display: block;
            margin-left: auto;
          }
        }
        .capacity-content{
          .el-form-item__content{
            display: flex;
          }
          .el-input{
            margin-right: 1rem;
            width: 80px;
          }
          .des{
            margin-right: 1rem;
          }
          .el-button-ml{
            background-color: #BE2316;
            color:#ffffff;
          }
        }
        /*复选组样式 start*/
        .el-checkbox-button{
          margin-right: 1rem;
        }
        .el-checkbox-button:first-child .el-checkbox-button__inner{
          border-radius:0!important;
        }
        .el-checkbox-button:last-child .el-checkbox-button__inner{
          border-radius:0!important;
        }
        .el-checkbox-button.is-checked .el-checkbox-button__inner{
          background-color: #BE2316;
          border-color:#BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }
        .el-checkbox-button__inner:hover{
          color: #BE2316;
        }
        .el-checkbox-button .el-checkbox-button__inner{
          border:none !important;
        }
        .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner{
          border-left-color: #BE2316
        }
        /*复选组样式 end*/
        /*单选组样式 start*/
        .el-radio-button{
          margin-right: 1rem;
        }
        .el-radio-button:first-child .el-radio-button__inner{
          border-radius:0!important;
        }
        .el-radio-button:last-child .el-radio-button__inner{
          border-radius:0!important;
        }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner{
          background-color: #BE2316;
          border-color:#BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }
        .el-radio-button__inner:hover{
          color: #BE2316;
        }
        .el-radio-button .el-radio-button__inner{
          border:none !important;
        }
        .el-radio-button.is-checked:first-child .el-radio-button__inner{
          border-left-color: #BE2316
        }
        /*单选组样式 end*/
        .transport-data{
          display: flex;
          .el-input{
            margin-right: 1rem;
          }
          .des{
            margin-right: 1rem;
          }
        }
        .form-item{
          margin-right: 0;
          .form-item-btn{
            background: #BE2316;
            border: none;
            i{
              font-size: 14px;
              padding-right: 10px;
            }
          }
        }
      }
    }
    .content{
      position: relative;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 50px;
      .content-img{
        width: 1200px;
      }
      .content-shoucang-tc{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -85px;
        margin-top: -35px;
      }
      .content-baojia{
        position: absolute;
        width: 50px;
        height: 100%;
        right: 0;
        top: 0;
      }
      .content-shoucang{
        position: absolute;
        width: 50px;
        height: 100%;
        right: 50px;
        top: 0;
      }

    }
    /*表格相关*/
    .table-wrap{
      width: 1200px;
      margin: 0 auto;
    }
  }

  .invitation-data {

    .invitation-form{
      .condition-group{
        margin-top: 0.5rem;
        padding-left: 8px;
      }
    }
    .invitation-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          padding: 5px 0.4%;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16.6%;
          }
          &:nth-child(2) {
            flex-basis: 16.6%;
          }
          &:nth-child(3) {
            flex-basis: 16.6%;
          }
          &:nth-child(4) {
            flex-basis: 14.1%;
          }
          &:nth-child(5) {
            flex-basis: 14.1%;
          }
          &:nth-child(6) {
            flex-basis: 18%;
            padding: 0;
          }
        }
      }
    }
    .invitation-data-body {
      position: relative;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 55px;
            padding: 5px 0.4%;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 16.6%;
            }
            &:nth-child(2) {
              flex-basis: 16.6%;
            }
            &:nth-child(3) {
              flex-basis: 16.6%;
            }
            &:nth-child(4) {
              flex-basis: 14.1%;
            }
            &:nth-child(5) {
              flex-basis: 14.1%;
            }
            &:nth-child(6) {
              flex-basis: 18%;
              overflow: initial;
              padding: 0;
              white-space: initial;
            }
            /deep/ .el-button.is-plain {
              background-color: white;
              color: #be2316;
              border-color: #be2316;
              padding: 7px 4px !important;
              width: 56px;
              span > i {
                transition: 1s all;
                transform: rotateZ(90deg);
                &.expand {
                  transform: rotateZ(-90deg);
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .invitation-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
</style>

